/* GRNS AI Help Bot — floating robot button + popup chat
   Calls https://grns-insights-hub.vercel.app/api/grns-chat
   Strict knowledge scope, fallback to support@grns.com.au */
(function () {
  'use strict';

  var ENDPOINT = 'https://grns-insights-hub.vercel.app/api/grns-chat';
  var STORAGE_KEY = 'grns_chat_history_v1';
  var SESSION_KEY = 'grns_chat_session_id_v1';
  var PAGE_HISTORY_KEY = 'grns_chat_page_history_v1';
  var PAGE_HISTORY_MAX = 10; /* last N distinct pages this session */

  /* Track pages this customer has visited during the session so Daisy can reference
     what they've been looking at when answering. Dedupe consecutive duplicates so
     hitting the same page twice doesn't fill the buffer. */
  (function trackPage() {
    try {
      var raw = sessionStorage.getItem(PAGE_HISTORY_KEY);
      var pages = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(pages)) pages = [];
      var here = location.pathname + (location.search || '');
      if (pages.length === 0 || pages[pages.length - 1] !== here) {
        pages.push(here);
        if (pages.length > PAGE_HISTORY_MAX) pages = pages.slice(-PAGE_HISTORY_MAX);
        sessionStorage.setItem(PAGE_HISTORY_KEY, JSON.stringify(pages));
      }
    } catch (e) {}
  })();
  function getPageHistory() {
    try {
      var raw = sessionStorage.getItem(PAGE_HISTORY_KEY);
      var pages = raw ? JSON.parse(raw) : [];
      return Array.isArray(pages) ? pages : [];
    } catch (e) { return []; }
  }

  /* Skip on the customer subscription portal — don't want to compete with the portal upsells */
  if (location.pathname.indexOf('/a/subscriptions') === 0 || location.pathname.indexOf('/a/loop_subscriptions') === 0) return;

  var history = [];
  try {
    var saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) history = JSON.parse(saved);
  } catch (e) {}

  /* Stable per-browser-tab session id. Persists across page navigations within the same tab
     so a customer who opens the chat on the homepage and continues on a product page is
     one session. Fresh tab = fresh session. */
  var sessionId = (function () {
    try {
      var id = sessionStorage.getItem(SESSION_KEY);
      if (id) return id;
      id = 's-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SESSION_KEY, id);
      return id;
    } catch (e) {
      return 's-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    }
  })();

  function saveHistory() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(-20))); } catch (e) {}
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'style') Object.assign(n.style, attrs[k]);
      else if (k === 'class') n.className = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    if (children) [].concat(children).forEach(function (c) {
      if (typeof c === 'string') n.appendChild(document.createTextNode(c));
      else if (c) n.appendChild(c);
    });
    return n;
  }

  /* Floating button — white speech-bubble outline icon */
  var btn = el('button', {
    class: 'grns-chat-btn',
    type: 'button',
    'aria-label': 'Open chat with Daisy, the GRNS helper'
  });
  btn.innerHTML = '<svg class="grns-chat-btn__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';

  /* Pulse indicator the first time someone visits */
  var seenKey = 'grns_chat_seen_v1';
  if (!localStorage.getItem(seenKey)) {
    btn.classList.add('grns-chat-btn--pulse');
  }

  /* Chat window */
  var win = el('div', { class: 'grns-chat-win', 'aria-hidden': 'true' });
  var hdr = el('div', { class: 'grns-chat-hdr' }, [
    el('div', { class: 'grns-chat-hdr__title' }, [
      el('span', { class: 'grns-chat-hdr__bot', html: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>' }),
      el('span', {}, 'Daisy')
    ]),
    el('button', { class: 'grns-chat-close', type: 'button', 'aria-label': 'Close' }, '×')
  ]);
  var body = el('div', { class: 'grns-chat-body' });
  var inputRow = el('form', { class: 'grns-chat-input' });
  var input = el('input', {
    type: 'text',
    placeholder: 'Ask about products, shipping, subscription…',
    maxlength: '500',
    autocomplete: 'off',
    'aria-label': 'Your message'
  });
  var send = el('button', { class: 'grns-chat-send', type: 'submit', 'aria-label': 'Send' }, '↑');
  inputRow.appendChild(input);
  inputRow.appendChild(send);

  win.appendChild(hdr);
  win.appendChild(body);
  win.appendChild(inputRow);

  document.body.appendChild(btn);
  document.body.appendChild(win);

  /* Render existing history if any */
  function appendMessage(role, text, opts) {
    opts = opts || {};
    var row = el('div', { class: 'grns-chat-msg grns-chat-msg--' + role });
    var bubble = el('div', { class: 'grns-chat-bubble' });
    /* Convert plain URLs + emails to links, and **bold** to <strong> */
    var safe = String(text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      /* Linkify URLs but exclude trailing punctuation so links don't break */
      .replace(/(https?:\/\/[^\s<>"]+?)([.,;:!?)\]]*)(?=\s|$)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>$2')
      .replace(/\b(grns\.com\.au[^\s<>"]+?)([.,;:!?)\]]*)(?=\s|$)/g, '<a href="https://www.$1" target="_blank" rel="noopener">$1</a>$2')
      .replace(/\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g, '<a href="mailto:$1">$1</a>')
      .replace(/\n/g, '<br>');
    bubble.innerHTML = safe;
    row.appendChild(bubble);
    body.appendChild(row);
    if (!opts.skipScroll) body.scrollTop = body.scrollHeight;
    return row;
  }

  /* Quick-action chips shown under the greeting on a fresh chat */
  var MANAGE_URL = 'https://grns-insights-hub.vercel.app/manage';
  function chipStyle() {
    return {
      display: 'block', width: '100%', textAlign: 'left', background: '#fff',
      border: '1px solid #cdd9c6', borderRadius: '12px', padding: '10px 12px',
      font: 'inherit', fontSize: '13.5px', color: '#19440a', cursor: 'pointer',
      marginTop: '8px', lineHeight: '1.35'
    };
  }
  function addQuickActions() {
    var wrap = el('div', { class: 'grns-chat-quick', style: { padding: '0 4px 6px' } });
    var manage = el('button', { type: 'button', style: chipStyle() });
    manage.innerHTML = '<strong>Manage my subscription</strong><br><span style="color:#6b6b6b;font-size:12px">Delay your next box, skip an order or change flavour</span>';
    var ask = el('button', { type: 'button', style: chipStyle() });
    ask.innerHTML = '<strong>Ask a question</strong><br><span style="color:#6b6b6b;font-size:12px">Products, ingredients, shipping, anything GRNS</span>';
    manage.addEventListener('click', function () {
      window.open(MANAGE_URL, '_blank', 'noopener');
      appendMessage('bot', "I've opened the subscription manager in a new tab. Pop in the email on your subscription and we'll send you a quick code, takes about 30 seconds.");
    });
    ask.addEventListener('click', function () {
      wrap.remove();
      input.focus();
    });
    wrap.appendChild(manage);
    wrap.appendChild(ask);
    body.appendChild(wrap);
    body.scrollTop = body.scrollHeight;
  }

  /* Seed greeting if history empty */
  function seed() {
    if (history.length === 0) {
      appendMessage('bot', "Hi, I'm Daisy. What can I help with?");
      addQuickActions();
    } else {
      history.forEach(function (m) { appendMessage(m.role === 'user' ? 'user' : 'bot', m.content, { skipScroll: true }); });
      requestAnimationFrame(function () { body.scrollTop = body.scrollHeight; });
    }
  }

  function openWin() {
    win.classList.add('grns-chat-win--open');
    win.setAttribute('aria-hidden', 'false');
    btn.classList.remove('grns-chat-btn--pulse');
    localStorage.setItem(seenKey, '1');
    if (!body.dataset.seeded) {
      seed();
      body.dataset.seeded = '1';
    }
    setTimeout(function () { input.focus(); }, 100);
  }
  function closeWin() {
    win.classList.remove('grns-chat-win--open');
    win.setAttribute('aria-hidden', 'true');
  }

  btn.addEventListener('click', function () {
    if (win.classList.contains('grns-chat-win--open')) closeWin();
    else openWin();
  });
  hdr.querySelector('.grns-chat-close').addEventListener('click', closeWin);

  function showTyping() {
    var row = el('div', { class: 'grns-chat-msg grns-chat-msg--bot grns-chat-msg--typing' });
    var bubble = el('div', { class: 'grns-chat-bubble' }, [
      el('span', { class: 'grns-chat-dot' }),
      el('span', { class: 'grns-chat-dot' }),
      el('span', { class: 'grns-chat-dot' })
    ]);
    row.appendChild(bubble);
    body.appendChild(row);
    body.scrollTop = body.scrollHeight;
    return row;
  }

  inputRow.addEventListener('submit', function (e) {
    e.preventDefault();
    var msg = input.value.trim();
    if (!msg) return;
    input.value = '';
    appendMessage('user', msg);
    history.push({ role: 'user', content: msg });
    saveHistory();
    var typingRow = showTyping();
    send.disabled = true; input.disabled = true;

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: msg,
        history: history.slice(0, -1),
        session_id: sessionId,
        page: (location.pathname + (location.search || '')).slice(0, 200),
        page_history: getPageHistory().slice(0, PAGE_HISTORY_MAX).map(function (p) { return String(p).slice(0, 200); })
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        typingRow.remove();
        var reply = data && data.reply ? data.reply : '';
        if (!reply) {
          reply = "I'm having trouble right now, please email support@grns.com.au and the team will help.";
        }
        appendMessage('bot', reply);
        history.push({ role: 'assistant', content: reply });
        saveHistory();
      })
      .catch(function () {
        typingRow.remove();
        appendMessage('bot', "Connection error, please try again or email support@grns.com.au.");
      })
      .then(function () {
        send.disabled = false; input.disabled = false;
        input.focus();
      });
  });
})();
